var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.modalopen
    ? _c("confirmation-component", {
        attrs: {
          "modal-open": _vm.modalopen,
          title: _vm.title,
          html: _vm.message,
        },
        on: { close: _vm.cancel },
        scopedSlots: _vm._u(
          [
            {
              key: "body",
              fn: function () {
                return [
                  _c("div", {
                    staticClass: "text-justify",
                    domProps: { innerHTML: _vm._s(_vm.message) },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "buttons",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "iris-confirm-buttons" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "action-btn",
                          attrs: { medium: "", elevation: "4" },
                          on: { click: _vm.cancel },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.cancelLabel != undefined
                                  ? _vm.cancelLabel
                                  : _vm.$t("common.btn_cancel")
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "action-btn",
                          attrs: {
                            color: "success",
                            medium: "",
                            elevation: "4",
                          },
                          on: { click: _vm.confirm },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.confirmLabel != undefined
                                  ? _vm.confirmLabel
                                  : _vm.$t("common.lblSave")
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2492071986
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }